<template>
  <section :class="$style.root">
    <div :class="$style.container">

      <RotatedHeading>
        <h3>Присоединяйся к нам</h3>
      </RotatedHeading>

      <div :class="$style.wrapper">

        <div>
          <h2 :class="$style.subHeading">
            Объединяй идеи <br>
            Развивайся <br>
            Создавай
          </h2>
          <router-link
            :class="$style.button"
            to="/join"
          >
            Присоединиться
          </router-link>
        </div>

        <div :class="$style.imgWrapper">
          <app-image
            v-for="(item, index) in images"
            :key="index"
            :alt="item.name"
            :x1="item.src.x1"
            :x2="item.src.x2"
            :class="[$style.img, item.sizeClass]"
            lazy
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RotatedHeading from 'components/RotatedHeading';

export default {
  name: 'HomeJoin',
  components: {
    RotatedHeading,
  },
  data() {
    return {
      images: [
        {
          src: {
            x1: '/images/photos/home_photo_3.jpg',
            x2: '/images/photos/home_photo_3@2x.jpg',
            placeholder: '/images/photos/home_photo_3@placeholder.jpg',
            webp: '/images/photos/home_photo_3.webp',
          },
          name: 'Join-3',
          sizeClass: this.$style.large,
        },
        {
          src: {
            x1: '/images/photos/home_photo_2.jpg',
            x2: '/images/photos/home_photo_2@2x.jpg',
            placeholder: '/images/photos/home_photo_2@placeholder.jpg',
            webp: '/images/photos/home_photo_2.webp',
          },
          name: 'Join-2',
          sizeClass: this.$style.medium,
        },
        {
          src: {
            x1: '/images/photos/students.jpg',
            x2: '/images/photos/students.jpg',
            placeholder: '/images/photos/students@placeholder.jpg',
            webp: '/images/photos/students.webp',
          },
          name: 'Join-1',
          sizeClass: this.$style.small,
        },
      ],
    };
  },
};
</script>

<style lang="scss" module>
/* stylelint-disable */
@import '../styles/variables';
@import '../styles/helpers';

.root {
  @extend %section;
}

.container {
  @extend %container;
}

.wrapper {
  @extend %content;
  position: relative;

  @include media('<=desktop') {
    padding-bottom: 90px;
  }
}

.subHeading {
  @extend %heading;
  text-align: left;
}

.button {
  @extend %button;
  padding-left: 15px;
  padding-right: 15px;

  @include media('<=desktop') {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

$img-lg-width: 48.96%;
$img-md-width: 33.12%;
$img-sm-width: 25.74%;

$overlapping-top: -8%;
$overlapping-right: -3.91%;

.imgWrapper {
  display: flex;
  flex-flow: row-reverse nowrap;
  align-items: center;
  justify-content: flex-end;
  margin-top: $overlapping-top;
}

.img {
  margin-right: $overlapping-right;

  &.large {
    width: $img-lg-width;
    margin-right: 0;
  }

  &.medium {
    width: $img-md-width;
  }

  &.small {
    width: $img-sm-width;
  }

  img,
  source {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeJoin.vue